"use client"

const services = [
  { name: "Food", icon: "bi-bag-heart", className: "loader-service-food" },
  { name: "Catering", icon: "bi-egg-fried", className: "loader-service-catering" },
  { name: "DineZone", icon: "bi-shop", className: "loader-service-dine" },
  { name: "PartyZone", icon: "bi-balloon-heart", className: "loader-service-party" },
  { name: "Courier", icon: "bi-truck", className: "loader-service-courier" },
]

const LoadingScreen = () => (
  <div className="katchit-loader" role="status" aria-live="polite" aria-label="Katchit is loading">
    <div className="loader-glow loader-glow-one" />
    <div className="loader-glow loader-glow-two" />

    <div className="loader-content">
      <div className="loader-brand">
        <img src="/assets/Frame.svg" alt="Katchit" />
        <span>Everything you need, in one place</span>
      </div>

      <div className="loader-service-stage" aria-hidden="true">
        <div className="loader-orbit loader-orbit-outer" />
        <div className="loader-orbit loader-orbit-inner" />
        <div className="loader-center-pulse">
          <div className="loader-center-icon"><i className="bi bi-geo-alt-fill" /></div>
          <span className="loader-center-ring" />
          <span className="loader-center-ring loader-center-ring-delayed" />
        </div>

        {services.map(service => (
          <div className={`loader-service ${service.className}`} key={service.name}>
            <span><i className={`bi ${service.icon}`} /></span>
            <small>{service.name}</small>
          </div>
        ))}
      </div>

      <div className="loader-copy">
        <h2>Bringing Katchit closer to you</h2>
        <p>Food, venues, celebrations and delivery—all coming together.</p>
      </div>

      <div className="loader-progress-wrap">
        <div className="loader-progress"><span /></div>
        <div className="loader-progress-label">
          <span>Getting things ready</span>
          <span className="loader-dots"><i /><i /><i /></span>
        </div>
      </div>
    </div>
  </div>
)

export default LoadingScreen
